var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DsmaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    stroke: "#6D29FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23L10 25.5L12.5 31H25.5L32.5 17L25.5 3H12.5L10 8L17 11L11 17L17 23Z",
    fill: "#6D29FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17L17 23L10 25.5H20L32.5 17Z",
    fill: "#501EBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17L17 11L10 8H20L32.5 17Z",
    fill: "#501EBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.156 37L14.21 33.92H14.188C14.1917 33.9933 14.1972 34.1033 14.2045 34.25C14.2118 34.3967 14.2192 34.5543 14.2265 34.723C14.2338 34.888 14.2375 35.0383 14.2375 35.174V37H13.495V33.073H14.628L15.5575 36.076H15.574L16.5585 33.073H17.6915V37H16.916V35.141C16.916 35.0163 16.9178 34.8733 16.9215 34.712C16.9288 34.5507 16.9343 34.3985 16.938 34.2555C16.9453 34.1088 16.9508 33.9988 16.9545 33.9255H16.9325L15.9205 37H15.156ZM21.087 37L20.801 36.065H19.371L19.085 37H18.1885L19.5745 33.0565H20.592L21.9835 37H21.087ZM20.317 34.4535C20.2986 34.3912 20.2748 34.3123 20.2455 34.217C20.2161 34.1217 20.1868 34.0245 20.1575 33.9255C20.1281 33.8265 20.1043 33.7403 20.086 33.667C20.0676 33.7403 20.042 33.832 20.009 33.942C19.9796 34.0483 19.9503 34.151 19.921 34.25C19.8953 34.3453 19.8751 34.4132 19.8605 34.4535L19.58 35.3665H20.603L20.317 34.4535ZM25.6543 37H24.7028L23.7898 35.515L22.8768 37H21.9858L23.2893 34.976L22.0683 33.073H22.9868L23.8338 34.4865L24.6643 33.073H25.5608L24.3288 35.02L25.6543 37Z",
    fill: "#6D29FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DsmaxIcon);
export default __webpack_public_path__ + "static/media/3dsmax_icon.d027790108be113a2a472b7004df1f7a.svg";
export { ForwardRef as ReactComponent };